import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const logisticTasks = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_LOGISTIC_TASKS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LOGISTIC_TASKS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data.map((x) => {
        return {
          ...x,
          'uniqueId': `${x.serviceCode1}${x.serviceCode2}${x.serviceCode3}`,
        };
      }),
    }),
    [ActionTypes.FETCHED_LOGISTIC_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
